<template>
    <div id="single-post-content">
        <div class="single-post">
            <div class="post-content-area pr-lg-4">
                <div class="row">
                    <div class="col-12 post-media post-featured-image">
                        <a href="#" class="gallery-popup cboxElement aa">
                            <img :src="photo" class="photo img-fluid" :alt="post.title">
                        </a>
                        <div class="thumb-source" v-if="post.thumbnail_source" v-html="thumbnail_source"></div>
                    </div>
                </div>
                <div class="row info mx-auto mb-5 form-group" v-if="post.menu_type === 'draft'" :class="{
                    'bg-danger': post.menu_type === 'draft',
                    }">
                    <i class="fas fa-info-circle"></i>
                    <span v-if="post.menu_type === 'draft'">Ez a cikk piszkozat NE OSZD MEG INNEN!</span>
                </div>
                <div class="row">
                    <div class="col-12 pt-2 paragraph-content font-weight-bold" v-html="short_content"></div>
                </div>
                <div class="row">
                    <div class="col-12 pt-2"
                    v-if="(paragraph_190 && paragraph_190.id) || (gparagraph_190 && gparagraph_190.id) ">
                        <ad :data="paragraph_190" v-if="(paragraph_190 && paragraph_190.id)"></ad>
                        <google-ad :data="gparagraph_190" v-if="(gparagraph_190 && gparagraph_190.id)"></google-ad>
                    </div>
                </div>
                <div class="row" :class="{ 'mt-0': (gparagraph_190 && gparagraph_190.id) }">
                    <div class="col-12 entry-content" v-html="post.content"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex'
    import Ad from '../../addons/Ad'
    import GoogleAd from '../../addons/GoogleAd'
    import { resizedThumbnail, replaceLinks } from "../../../helpers/helpers";

    export default {
        name: 'SinglePostContent',
        props: ['data', 'banner', 'gbanner'],
        data() {
            return {
                post: this.data ? this.data : {},
                paragraph_190: this.banner ? this.banner : {},
                gparagraph_190: this.gbanner ? this.gbanner: {},
            }
        },
        components: {
            Ad,
            GoogleAd,
        },
        computed: {
            thumbnail_source() {
                return 'Fotó: '+this.post.thumbnail_source;
            },
            short_content() {
                return replaceLinks(this.post.short_content);
            },
            photo() {
                if(this.post.photo) {
                    return this.post.photo.replace('height', '_height');
                }

                return this.post.photo
            }
        },
        methods: {
            ...mapActions([
                'updateVisitors',
                'getPost',
            ]),
            resizedThumbnail(url, height) {
                return resizedThumbnail(url, height);
            }
        },
        mounted() {

        },
        watch: {
            data: function (newVal) {
                this.post = newVal;

                if(this.$route.query) {
                    if(this.$route.query.d && this.$route.query.d == 1 && this.post.id === undefined) {
                        window.location.href = this.$route.path;
                    }
                }

                if(newVal && newVal.id) {
                    this.updateVisitors({ id: this.post.id });
                    this.$gtag.event('post', { title: newVal.title, url: newVal.url });
                }

            },
            banner: function(newVal) {
                this.paragraph_190 = newVal;
            },
            gbanner: function(newVal) {
                this.gparagraph_190 = newVal;
            },
        }
    }
</script>

<style lang="scss">
    @import '~@/absctracts/variables.scss';

    #single-post-content {

        .single-post {
            .post-featured-image {
                max-height: 370px;
                overflow: hidden;
                position: relative;

                @media (max-width: 576px) {
                    .thumb-source {
                        height: 30px !important;
                        font-size: 14px !important;
                        width: 91.6% !important;
                        padding-bottom: 0px !important;
                        top: 88% !important;
                    }
                }

                .thumb-source {
                    position: absolute;
                    top: 91%;
                    text-align: right;
                    width: 96.1%;
                    color: white;
                    background-color: #000;
                    padding: 5px;
                }
            }
        }
        .entry-content {
            padding-top: 20px;
            text-align: justify;

            p {
                font-size: 15px;
                line-height: 26px;
                margin-bottom: 15px;
            }

            .alt {
                background-color: #1c1c1c;
                padding: 10px;
                margin-top: 11px;
                color: #999;
                width: 100%;
                font-size: 13px;
            }

            blockquote {
                position: relative;
                background: #f7f7f7;
                padding: 45px 50px 30px;
                border: 0;
                margin: 50px 0 40px;
                font-size: 22px;
                line-height: 34px;
                font-family: Arimo, sans-serif;
                font-weight: 400;
                text-align: center;

                p {
                    font-weight: 700;
                    background-color: transparent;
                }
            }

            blockquote:before {
                position: absolute;
                content: '\201C';
                font-family: Georgia, serif;
                font-size: 69px;
                padding: 30px 10px 0px 10px;
                top: -30px;
                left: 45px;
                margin-left: -44px;
                color: #fff;
                background: #ec0000;
            }

            .internal-post {
                background: #f7f7f7;
                border-left: 3px solid $red;
                font-family: Arimo, sans-serif;
                font-size: 22px;
                font-weight: 400;
                line-height: 34px;
                margin: 20px 0 20px;
                padding: 15px;
                position: relative;
                text-align: center;

                .img {
                    overflow: hidden;

                    img {
                        width: 130%;
                        height: 150px;
                    }
                }

                .content {
                    text-align: left;

                    a {
                        color: $dark-grey;
                    }

                    a:hover {
                        text-decoration: underline;
                    }

                    .desc {
                        background-color: transparent;
                        padding-top: 10px;
                    }
                }
            }
        }
    }
    .fb {
        background-color: #365899;
        font-size: 13px;
        cursor: pointer;

        span {
            padding: 5px;
            cursor: pointer;
        }
    }

    .info {
        padding: 15px;
        font-size: 18px;
        color: white;
        text-align: center;

        svg, i {
            position: relative;
            top: 2px;
            right: 5px;
        }
    }

    .photo {
        width: 100%;
    }

</style>
